import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const useNavigateBack = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateBack = useCallback(() => {
    const isInitialLocation: boolean = location.key === 'default';
    const to: any = isInitialLocation ? '/' : -1;
    navigate(to);
  }, []);

  return navigateBack;
};

export default useNavigateBack;
